import {
  SET_DATA_QUALITY_LOADING_STATE,
  SET_DATA_QUALITY,
  SET_BAR_CHART_DATA,
  OPEN_VALIDITY_DRAWER,
  CLOSE_VALIDITY_DRAWER,
  UPDATE_VALIDITY_DRAWER,
  UPDATE_CHARTS,
  SET_INITIAL_PERIOD_BAR_CHART_DATA,
  CHANGE_CURRENT_PAGE,
  SET_FILTERS,
} from '@/store/modules/data-quality/mutation-types';

export default {
  [SET_DATA_QUALITY_LOADING_STATE](state, payload) {
    state.isLoading[payload.key] = payload.value;
  },
  [SET_DATA_QUALITY](state, payload) {
    const {data, tags, origins, views} = payload;

    state.qualityTablesData = data;
    state.tags = tags;
    state.origins = origins;
    state.views = views;
    state.currentView = views[0];
  },
  [SET_BAR_CHART_DATA](state, payload) {
    const {main, chart} = payload;
    state.barChartData = main;
    state.periodBarChart = chart;
  },
  [UPDATE_VALIDITY_DRAWER](state, payload) {
    state.validityDrawer.data.items = payload;
  },
  [OPEN_VALIDITY_DRAWER](state, payload) {
    state.validityDrawer = {
      isOpen: true,
      data: {
        ...payload,
        items: null,
      },
    };
  },
  [CLOSE_VALIDITY_DRAWER](state) {
    state.validityDrawer = {
      isOpen: false,
      data: null,
    };
  },
  [UPDATE_CHARTS](state, payload) {
    state.filteredTableData = payload;
  },
  [SET_INITIAL_PERIOD_BAR_CHART_DATA](state, payload){
    state.initialPeriodBarChartData = payload;  
  },
  [CHANGE_CURRENT_PAGE](state, payload){
    state.currentPage = payload;
  },
  [SET_FILTERS](state, filters) {
    Object.assign(state, filters);
  },
};